import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24Like1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M15.378 4.007a5.6 5.6 0 0 0-3.517 1.478l-.133.128.041.04A5.56 5.56 0 0 0 7.8 4a5.6 5.6 0 0 0-4 1.68 6.41 6.41 0 0 0-.452 8.386l.168.207q.176.216.368.44l.4.453.211.23.44.464.46.467q.116.117.236.233l.482.463.245.23.495.45q.374.334.747.649l.494.409.486.386c1.282.993 2.43 1.694 3.068 1.76l.092.004c.716-.073 1.995-.863 3.388-1.959l.495-.399.25-.208.501-.43.5-.445.248-.227.489-.46.476-.467a27 27 0 0 0 1.691-1.839l.178-.218c2.112-2.497 1.99-6.207-.292-8.574A5.6 5.6 0 0 0 15.66 4zm.281 1.393a4.2 4.2 0 0 1 3 1.26 5.01 5.01 0 0 1 .366 6.522l-.311.384c-.397.478-.868.992-1.378 1.51l-.445.443-.46.442-.466.435-.47.424-.235.207-.466.399-.455.378-.44.35-.214.165-.409.304c-.659.477-1.202.799-1.522.876l-.05.008.015.004c-.239-.026-.693-.28-1.269-.685l-.36-.26-.384-.293-.405-.321-.21-.17-.427-.359-.437-.377-.443-.394-.443-.405-.439-.414-.43-.419-.42-.42-.203-.208-.391-.415-.368-.406-.34-.394-.157-.191a5.014 5.014 0 0 1 .21-6.723 4.198 4.198 0 0 1 5.997.003l.93.846.9-.817A4.23 4.23 0 0 1 15.66 5.4z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24Like1$1 = Svg24Like1;

export { Svg24Like1$1 as default };
